import { render, staticRenderFns } from "./sidenav.vue?vue&type=template&id=d8a7f9aa&scoped=true&"
import script from "./sidenav.vue?vue&type=script&lang=js&"
export * from "./sidenav.vue?vue&type=script&lang=js&"
import style0 from "./sidenav.vue?vue&type=style&index=0&id=d8a7f9aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a7f9aa",
  null
  
)

export default component.exports